import styled from "styled-components";

export default styled.div`
  .not-found-message {
    display: flex;
    flex-flow: column nowrap;
    opacity: 0.2;
    justify-content: center;
    align-items: center;

    & > * {
      max-width: 300px;
      text-align: center;
    }
  }
`;
